module.exports = __webpack_public_path__ + "img/icon_time_black.0565b6ca.svg";